import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';
import Loader from '../../Loader';
import './styles.scss';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  currentItem: PropTypes.object.isRequired,
};

const defaultProps = {
  loading: true,
};

class WeatherPanel extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      useFahrenheit: true,
      currentTime: Date.now(),
    };

    this.formatTemp = this.formatTemp.bind(this);
    this.changeTempFormat = this.changeTempFormat.bind(this);
    this.convertTemp = this.convertTemp.bind(this);
    this.displayMoonPhase = this.displayMoonPhase.bind(this);
    this.interval = null;
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ currentTime: Date.now() });
    }, 1000);
  }

  componentWillMount() {
    const userTimezone = moment.tz.guess();
    if (userTimezone.split('/')[0] !== 'America') {
      this.setState({ useFahrenheit: false });
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  formatTemp(temp) {
    if (isNaN(parseFloat(temp)) || !isFinite(temp)) return '';
    if (this.state.useFahrenheit) {
      return (<span>{this.convertTemp(temp)}<sup>&deg;</sup><span className="smaller-text">&nbsp;F</span></span>);
    }
    return (<span>{this.convertTemp(temp)}<sup>&deg;</sup><span className="smaller-text">&nbsp;C</span></span>);
  }

  changeTempFormat(useFahrenheit, e) {
    e.preventDefault();
    this.setState({ useFahrenheit });
  }

  convertTemp(temp) {
    return (this.state.useFahrenheit) ? temp : Math.round((temp - 32) * (5 / 9));
  }

  displayMoonPhase(age, index) {
    let phase = age;
    if (index > 0) {
      phase = parseInt(age, 10) + parseInt(index, 10);
      if (phase > 28) phase -= 28;
    }

    // Because the font files are reversed
    let correctedPhase = phase - 14;
    if (correctedPhase <= 0) correctedPhase += 28;
    correctedPhase = (`0${correctedPhase}`).slice(-2);

    return (<i className="icon-Moon" />);
  }

  getContent() {
    const { currentItem } = this.props;
    const weather = _.get(currentItem, 'weather');
    let location = _.get(currentItem, 'location_text');
    const forecast = _.get(weather, 'forecast');
    const camTimeZone = _.get(weather, 'current.timezone');

    const { currentTime } = this.state;
    if (!weather || (_.isEmpty(weather.current) && _.isEmpty(weather.forecast))) return null;
    const userTimezone = moment.tz.guess();
    const locationPieces = location.split(/,(.+)/);
    location = (locationPieces.length > 1) ? `${locationPieces[0]}<br />${locationPieces[1]}` : location;
    const formatTemp = this.formatTemp;
    const convertTemp = this.convertTemp;
    const displayMoonPhase = this.displayMoonPhase;
    const userInDifferentTimeZone = userTimezone !== camTimeZone;

    return (
      <div>
        <div data-carousel-controls="forecast-carousel">
          <div className="row m-0 pb-20">
            <div className="col-6">
              <div className="text-center">Sunrise </div>
              <div className="text-center u-textSize-16">
                <Moment format="hh:mm" tz={camTimeZone}>{ weather.current.sunrise }</Moment>
                <span className="smaller-text">
                  {' '}<Moment format="A z" tz={camTimeZone}>{ weather.current.sunrise }</Moment>
                </span>
                {userInDifferentTimeZone && (
                  <span>
                    {'  '}<Moment format="hh:mm" tz={userTimezone}>{ weather.current.sunrise }</Moment>
                    <span className="smaller-text">
                      {' '}<Moment format="A z" tz={userTimezone}>{ weather.current.sunrise }</Moment>
                    </span>
                  </span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="text-center">Sunset </div>
              <div className="text-center u-textSize-16">
                <Moment format="hh:mm" tz={camTimeZone}>{ weather.current.sunset }</Moment>
                <span className="smaller-text">
                  {' '}<Moment format="A z" tz={camTimeZone}>{ weather.current.sunset }</Moment>
                </span>
                {userInDifferentTimeZone && (
                  <span>{'  '}
                    <Moment format="hh:mm" tz={userTimezone}>{ weather.current.sunset }</Moment>
                    <span className="smaller-text">
                      {' '}<Moment format="A z" tz={userTimezone}>{ weather.current.sunset }</Moment>
                    </span>
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row m-0" style={{ borderBottom: '1px solid #5d5d59' }}>
            <div className="col-6 pb-20" style={{ borderRight: '1px solid #5d5d59' }}>
              <ul style={{ listStyle: 'none outside', padding: 0, margin: 0 }}>
                <li>
                  <Moment format="hh:mm" tz={camTimeZone}>{ currentTime }</Moment>
                  <span className="smaller-text">&nbsp;
                    <Moment format="A z" tz={camTimeZone}>{ currentTime }</Moment>
                  </span>
                </li>
                <li>{ convertTemp(weather.current.tempF) }<sup>&deg;</sup>
                  <div className="temp-selection">
                    <a
                      href="#"
                      className={this.state.useFahrenheit ? 'active' : ''}
                      onClick={e => this.changeTempFormat(true, e)}
                    >F</a>{' / '}
                    <a
                      href="#"
                      className={!this.state.useFahrenheit ? 'active' : ''}
                      onClick={e => this.changeTempFormat(false, e)}
                    >C</a>
                  </div>
                </li>
                <li>{ weather.current.weatherShort }</li>
              </ul>
            </div>
            <div className="col-6 pb-20 pl-50">
              <ul style={{ listStyle: 'none outside', padding: 0, margin: 0 }}>
                <li>Humidity { weather.current.humidity }</li>
                <li>Precipitation { weather.current.precipitation }%</li>
                <li>Wind { weather.current.windSpeed } <span className="smaller-text">MPH</span></li>
              </ul>
            </div>
          </div>
          <div className="forecast d-flex flex-row pb-20">
            {weather.forecast && forecast.slice(0, 6).map((thisForecast, i) => {
              return (
                <div className="forecast-block" key={i}>
                  <span className="day">
                    { thisForecast.weekday }
                  </span>
                  <span className="temp">
                    {formatTemp(thisForecast.temp)}
                  </span>
                  <span className="icon">
                    <img
                      className="desaturate"
                      src={`/images/weather-icons/${thisForecast.icon}.png`}
                      style={{ width: 50 }}
                      alt=""
                    />
                  </span>
                  { !!(weather.current.ageOfMoon) &&
                    <span className="moon">
                      {displayMoonPhase(weather.current.ageOfMoon, i)}
                    </span>
                  }
                </div>
              );
            })
            }
          </div>
          <div className="small text-right">
            <span className="small">
            Powered by  Weather and&nbsp;
              <a
                href="https://weatherkit.apple.com/legal-attribution.html"
                target="_blank"
                rel="noreferrer"
                className="text-body"
              >
                <u>other sources</u>
              </a>
            </span>
          </div>
          <ul style={{ padding: 0, margin: 0, display: 'none' }}>
            <li className="textColor-000 align-middle row">
              <div className="col-12">
                <span className="text-uppercase u-font-foundation-bold u-textSize-18 pr-10 panel-title">Prime Viewing</span>
                <span
                  className="panel-label u-font-foundation-roman u-textSize-18 pl-10"
                  data-panel-title="6:00AM - 7:00PM PST"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  // @todo: refactor this pattern of `loading ? <Loader /> : <content>` to a HoC
  render() {
    const { loading } = this.props;

    return (
      <div className={`widget panel weather ${loading ? 'loading' : ''}`}>
        {loading ? <Loader dark fill /> : this.getContent()}
      </div>
    );
  }
}

WeatherPanel.propTypes = propTypes;
WeatherPanel.defaultProps = defaultProps;

export default WeatherPanel;
